// extracted by mini-css-extract-plugin
module.exports = {"success":"StatusMarker-success-bd529c544f252414bf0fb1a37455cbfc","error":"StatusMarker-error-672d27d77d338489c12e3cec31da9de3"};